import React from 'react';
import _ from 'lodash';

import api from '../../../../services';

import AutoComplete from 'material-ui/AutoComplete';
import withExclusions from './withExclusions.js';
const type = 'cargoExclusionsV2'

const style = {
    wrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
};

class CargoExclusionsV2 extends React.Component {
    render() {
        const { getError, confirmed, cargoExclusionV2List, cargoExclusionsV2, modifiedFields, underStyle, renderExcl, choose, change, dataSource, currentExcl } = this.props;

        return (
            <React.Fragment>
                <div style={style.wrapper}>
                    {                       
                        renderExcl(type)
                    }
                </div>
                <AutoComplete
                    name='cargoExclusionV2'
                    disabled={confirmed}
                    dataSource={dataSource}
                    dataSourceConfig={{ text: 'name', value: 'cargoExclusionV2' }}
                    floatingLabelText='Cargo Exclussions'
                    searchText={currentExcl.name || ''}
                    onUpdateInput={change}
                    onNewRequest={excl => choose(type, excl)}
                    filter={AutoComplete.noFilter}
                    errorText={getError('cargoExclusionV2')}
                    listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                    popoverProps={{
                        canAutoPosition: true,
                    }}
                    fullWidth

                    underlineStyle={modifiedFields && modifiedFields.includes('cargoExclusionsV2') ? underStyle : null}
                />
            </React.Fragment>
        );
    }
}

export default withExclusions(api.getCargoNamesAutocomplete, CargoExclusionsV2);



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/CargoExclussionsV2.jsx